import { Occupation } from "@models/occupation";
import { Residency } from "@models/residency";
import { FamilyMember } from "@models/family-member";
import { Patient } from "@models/patient";

export enum Gender {
  Male = "Male",
  Female = "Female",
}

export interface Person {
  id: string;
  nickname: string;
  avatar?: File;
  avatarUrl?: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: Gender;
  birthDate?: string;
  birthLocation?: string;
  bio?: string;
  hobbies?: string;
  occupations: Occupation[];
  residencies: Residency[];
  familyMember?: FamilyMember;
  patient?: Patient;
  characterId?: string;
}
